export default {"src":"/_next/static/image/src/images/about/blue-paw.6049aef8ec2a546156f57963b0052cd1.svg","height":46,"width":46};